//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

//
// Component
//

export function clearMultiInput(multiTextInput: HTMLElement)
{
	const inputsContainer = BrowserUtilities.ElementClientLib.getElementOrThrow(multiTextInput, ".inputs-container");

	inputsContainer.replaceChildren();
}

export function addMultiInputInput(multiTextInput: HTMLElement, value: string)
{
	//
	// Get Elements
	//

	const maximumInputs = BrowserUtilities.ElementClientLib.getIntegerDataOrThrow(multiTextInput, "maximumInputs");

	const inputsContainer = BrowserUtilities.ElementClientLib.getElementOrThrow(multiTextInput, ".inputs-container");

	const addButton = BrowserUtilities.ElementClientLib.getElementOrThrow(multiTextInput, `[data-add-input="true"]`);

	//
	// Create Input
	//

	const multiInputInputTemplate = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLTemplateElement>(multiTextInput, "template");

	const multiInputInput = BrowserUtilities.ElementClientLib.cloneTemplateOrThrow(multiInputInputTemplate);

	const multiInputInputInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(multiInputInput, ".input");

	multiInputInputInput.value = value;

	inputsContainer.appendChild(multiInputInput);

	const removeInputButton = BrowserUtilities.ElementClientLib.getElementOrThrow(multiInputInput, ".remove");

	removeInputButton.addEventListener("click", 
		() =>
		{
			removeInputButton.parentElement?.remove();

			addButton.removeAttribute("disabled");

			const text = BrowserUtilities.ElementClientLib.getElementOrThrow(addButton, ".text");

			text.innerHTML = inputsContainer.children.length == 0 ? "Add" : "Add another";
		});

	//
	// Update Add Button
	//

	if (maximumInputs != -1 && inputsContainer.children.length >= maximumInputs)
	{
		addButton.setAttribute("disabled", "");
	}

	const text = BrowserUtilities.ElementClientLib.getElementOrThrow(addButton, ".text");

	text.innerHTML = inputsContainer.children.length == 0 ? "Add" : "Add another";
}

export function initialiseMultiInput(multiTextInput: HTMLElement)
{
	const values = JSON.parse(BrowserUtilities.ElementClientLib.getStringDataOrThrow(multiTextInput, "values")) as string[];

	const addButton = BrowserUtilities.ElementClientLib.getElementOrThrow(multiTextInput, `[data-add-input="true"]`);

	for (const value of values)
	{
		addMultiInputInput(multiTextInput, value);
	}

	addButton.addEventListener("click", () => addMultiInputInput(multiTextInput, ""));

	multiTextInput.classList.add("initialised");
}

export function initialiseMultiInputs()
{
	const multiTextInputs = document.querySelectorAll<HTMLElement>(".component-multi-input:not(.initialised)");

	console.log("[MultiInput] Initialising " + multiTextInputs.length + " instances...");

	for (const multiTextInput of multiTextInputs)
	{
		try
		{
			initialiseMultiInput(multiTextInput);
		}
		catch (error)
		{
			console.error("[MultiInput] Error initialising:", multiTextInput, error);
		}
	}
}